import React from 'react';

import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';

import Editor from 'src/constrains/BraftEditor';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getFooterNotes,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onFooterNotesChange,
} from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/slice';

const FooterNote = (props) => {
  const { data } = props;
  const d = useDispatch();
  const params: any = useParams();
  const { contentUuid } = params;
  const linkSet = useSalesChannelGeneralLinkSet({ contentUuid });
  return (
    <Section>
      <ItemWrapper title={getI18nFromGeneral('general.hOCTitle.footerNotes')}>
        <Editor
          linkSet={linkSet}
          data={data}
          onChange={({ data }) => {
            d(onFooterNotesChange(data));
            //onFooterNotesChange({ content: data });
          }}
          salesChannelContentUuid={contentUuid}
        />
      </ItemWrapper>
    </Section>
  );
};
export default ErrorProcessingHOC(FooterNote, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.footerNote,
  getContent: getFooterNotes,
  title: getI18nFromGeneral('general.hOCTitle.footerNotes'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  expandOffset: 0,
  getSubmitStamp,
  headerProps: {
    dotsFunction: [
      // {
      //   onClick: () => {
      //     const dD = generateFooterStyle();
      //     store.dispatch(onFooterStyleChange(dD));
      //   },
      //   key: 'Reset',
      //   body: 'Reset',
      //   isDangerous: true,
      // },
    ],
    hasDots: false,
    hideDotsWhenNotPrimary: true,
  },
});
